<div class="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center max-w-4xl mx-auto">
  <!-- Visual Success Icon Badge -->
  <div
    class="flex size-20 items-center justify-center rounded-full bg-green-a3 text-green-9 border border-green-a4 text-4xl shadow-md mx-auto mb-6 animate-bounce"
  >
    ✓
  </div>

  @if (badgeText()) {
    <span
      class="inline-flex items-center gap-x-1.5 rounded-full bg-green-a3 px-4 py-1.5 text-xs font-semibold text-green-11 ring-1 ring-inset ring-green-a4 mb-4"
    >
      {{ badgeText() }}
    </span>
  }

  <h1 class="text-3xl sm:text-5xl font-bold tracking-tight text-neutral-12">
    {{ title() }}
  </h1>

  <p class="mt-4 text-lg text-neutral-11 max-w-xl mx-auto leading-relaxed">
    {{ description() }}
  </p>

  <!-- Response Time Guarantee Banner -->
  @if (showResponseTime() && responseTimeText()) {
    <div
      class="mt-8 w-full max-w-xl bg-primary-a2 border border-primary-a4 rounded-2xl p-6 shadow-sm text-left"
    >
      <div class="flex items-start gap-x-4">
        <div class="p-3 bg-primary-9 text-white rounded-xl text-2xl font-bold flex-shrink-0">⏱️</div>
        <div>
          <h2 class="text-base font-bold text-neutral-12">{{ responseTimeTitle() }}</h2>
          <p class="mt-1 text-sm text-neutral-11">
            {{ responseTimeText() }}
          </p>
        </div>
      </div>
    </div>
  }

  <!-- Next Steps Grid if provided -->
  @if (nextSteps().length > 0) {
    <div
      class="mt-10 w-full max-w-2xl text-left bg-neutral-2 border border-neutral-a3 rounded-2xl p-6 sm:p-8"
    >
      <h2 class="text-lg font-bold text-neutral-12 mb-6 text-center sm:text-left">
        {{ nextStepsTitle() }}
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6">
        @for (step of nextSteps(); track step.stepNumber) {
          <div class="space-y-2">
            <span class="text-xs font-bold text-primary-9 uppercase tracking-wider"
              >Étape {{ step.stepNumber }}</span
            >
            <h3 class="text-sm font-bold text-neutral-12">{{ step.title }}</h3>
            <p class="text-xs text-neutral-11 leading-normal">{{ step.description }}</p>
          </div>
        }
      </div>
    </div>
  }

  <!-- Action Button -->
  <div class="mt-10 flex flex-wrap justify-center gap-4">
    <a
      [routerLink]="homeUrl()"
      class="rounded-xl bg-primary-9 px-8 py-3 text-sm font-bold text-white shadow-md hover:bg-primary-10 transition-all duration-200 cursor-pointer inline-flex items-center justify-center gap-x-2"
    >
      <span>← {{ homeButtonText() }}</span>
    </a>
  </div>
</div>
